<div class="header">
    <div class="title">
        <h3>{{'footer.privacy' | translate}}</h3>
        <div class="static">{{'footer.ourPrivacy' | translate}}</div>
    </div>
</div>


<div class="container">
    <div class="row mt-5 mb-3">
        <div class="col-md-12 privacy-list" [innerHtml]="result.content">
        </div>
    </div>
</div>
